import { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";

import { setPlace } from "@app/store/search.store";
import { useGoogle } from "@app/utils/google";
import { useTranslation } from "react-i18next";

export default function LocationSearchComponent({ onSubmit }: { onSubmit?: () => void }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [isLoaded] = useGoogle();
    const [autocomplete, setAutocomplete] = useState<google.maps.places.Autocomplete | null>(null);
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (isLoaded && inputRef.current && !autocomplete) {
            const newAutocomplete = new google.maps.places.Autocomplete(inputRef.current, {
                componentRestrictions: {
                    country: ['bg'],
                },
                types: ['address'],
                fields: ['address_components', 'geometry', 'name'],
            });
            setAutocomplete(newAutocomplete);
        }
    }, [isLoaded, autocomplete]);

    function haltEnterKey(e: any) {
        if ((e.key as string).toLowerCase() === 'enter') {
            e.preventDefault();
        }
    }

    function onSubmitForm(e: any) {
        e.preventDefault();
        if (autocomplete) {
            const place = autocomplete.getPlace();
            dispatch(setPlace(place));
            onSubmit?.();
        }
    }

    return (
        <div className="search_bar_list">
            <form onKeyDown={haltEnterKey} onSubmit={onSubmitForm}>
                <input
                    ref={inputRef}
                    type="text"
                    className="form-control"
                    placeholder={t('SEARCH_BY_ADDRESS_PLACEHOLDER')} />
                <button type="submit">{t('Търсене')}</button>
            </form>
        </div>
    );
}
